const Form = require("app/components/forms/Form");
const Textarea = require("app/components/fields/Textarea");
const Trans = require('app/components/trans/Trans')

class Contact extends Form {

  constructor(props) {
    super(props);
    this.textPlaceholder = translate("Skriv din besked her!");
  }

  get actionUrl() {
    return router.route("api.contact.contact-form", {});
  }

  onSubmit = (e) => {
    e.preventDefault();

    if (this.honeypot.value != "") {
      return;
    }
    this.performSubmit(e.target);
  };

  renderForm() {
    return (
      <form className="contact_form" ref={el => this.formElement = el}
            onSubmit={this.onSubmit}>
        <div className="inputs">
          <div className="field required">
            <label htmlFor="form_name"><Trans>Navn</Trans></label>
            <input type="text" id="form_name"
                   ref={el => this.name = el} name="name"
                   required={true}/>
            {this.renderError("name")}
          </div>
          <div className="field required">
            <label htmlFor="form_email"><Trans>Email</Trans></label>
            <input type="email" id="form_email"
                   ref={el => this.email = el} name="email"
                   required={true}/>
            {this.renderError("email")}
          </div>
          <div className="field required">
            <label htmlFor="form_text"><Trans>Besked</Trans></label>
            <Textarea ref={el => this.textInput = el}
                      id="textCardInput"
                      name={"text"}
                      onInput={this._onTextInput}
                      placeholder={this.textPlaceholder}/>i
            {this.renderError("text")}
          </div>
          <input id="set_email_false" name="email_field"
                 ref={el => this.honeypot = el} type="text" value=""/>
          <input type="submit" value={translate("Send")}/>
        </div>
        <div className={'contact-form-response'}>
          {this.renderMessage()}
        </div>
      </form>
    );
  }

}

module.exports = Contact;
